module.exports = __webpack_public_path__ + "static/media/start-a-company.8350345d.svg";